import HomePage from "./pages/HomePage/HomePage";
import Museum from "./pages/Museum/Museum";
import Orsini from "./pages/Orsini";
import RedirectToHomePage from "./utils/RedirectToHomePage";

const routes = [
  { path: "/", component: HomePage },
  { path: "/museo", component: Museum },
  { path: "/antonio-orsini", component: Orsini },
  // Catch all
  { path: "*", component: RedirectToHomePage },
];

export default routes;
